import { render } from "./LicenseDisplay.vue?vue&type=template&id=3605277a"
import script from "./LicenseDisplay.vue?vue&type=script&lang=js"
export * from "./LicenseDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__